var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('icon-button');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
export var IconButtonDefaultProps = {
  onClick: function () {},
  showChildren: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    font-family: ", ";\n    font-weight: 500;\n    &:hover {\n      ", ";\n      color: ", ";\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    font-family: ", ";\n    font-weight: 500;\n    &:hover {\n      ", ";\n      color: ", ";\n    }\n\n    ", "\n  "])), theme.FONT('sans'), theme.FILL('primary'), theme.COLOR('primary'), function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      opacity: 0.4;\n    "], ["\n      opacity: 0.4;\n    "])));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var usePadding = _a.usePadding;
    return usePadding && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding-right: ", ";\n    "], ["\n      padding-right: ", ";\n    "])), theme.UNIT(2));
  })
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var IconButton = function (props) {
  var className = props.className,
    children = props.children,
    icon = props.icon,
    iconSize = props.iconSize,
    iconColor = props.iconColor,
    onClick = props.onClick,
    disabled = props.disabled,
    title = props.title,
    showChildren = props.showChildren;
  return React.createElement(My.Container, {
    disabled: disabled,
    className: cls.name(className),
    onClick: onClick,
    title: title
  }, !!icon && React.createElement(My.Icon, {
    usePadding: showChildren,
    color: iconColor,
    size: iconSize
  }, icon), showChildren && children);
};
IconButton.defaultProps = IconButtonDefaultProps;
IconButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;